import React, { useState, useEffect, useRef } from "react";
import Map from "../../assets/Tali-Beach-Map.jpg";
import { useCompany } from "../../../context/CompanyContext";
import CompanyTerms from "../../../components/CompanyTerms";
import {
  addNewDoc,
  queryAllDocsByFieldSnap,
  updateDocById,
  deleteDocById,
  uploadFile,
  getDownloadURL,
} from "../../../utils/firebase/Firebase.utils";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  FiUpload,
  FiX,
  FiPaperclip,
  FiImage,
  FiVideo,
  FiMaximize2,
  FiTrash2,
  FiAlertCircle,
} from "react-icons/fi";
import FileUploadAndView from "../../User/Components/FileUploadAndView";
import EmergencyModal from "./EmergencyModal";
import { unitNumberLabel } from "../../../utils/constants";

// Generate floors from G to 55
const generateFloors = () => {
  const floors = [];

  // Add floors 2-39
  for (let i = 39; i >= 2; i--) {
    let floorUnits = [];

    // Special case for 39th floor
    if (i === 39) {
      floorUnits = [
        {
          unitNumber: "39A",
          tenantName: "",
          emergencyContact: "",
          type: "Residential",
        },
        {
          unitNumber: "39B",
          tenantName: "",
          emergencyContact: "",
          type: "Residential",
        },
        {
          unitNumber: "MOTHER METER",
          tenantName: "",
          emergencyContact: "",
          type: "Utility",
        },
      ];
    }
    // Special case for 38th floor
    else if (i === 38) {
      floorUnits = [
        {
          unitNumber: "38A",
          tenantName: "",
          emergencyContact: "",
          type: "Residential",
        },
        {
          unitNumber: "38B",
          tenantName: "",
          emergencyContact: "",
          type: "Residential",
        },
        {
          unitNumber: "38C",
          tenantName: "",
          emergencyContact: "",
          type: "Residential",
        },
        {
          unitNumber: "38D",
          tenantName: "",
          emergencyContact: "",
          type: "Residential",
        },
      ];
    }
    // Floors 32-37 (8 units)
    else if (i >= 32 && i <= 37) {
      floorUnits = [
        {
          unitNumber: `${i}A`,
          tenantName: "",
          emergencyContact: "",
          type: "Residential",
        },
        {
          unitNumber: `${i}B`,
          tenantName: "",
          emergencyContact: "",
          type: "Residential",
        },
        {
          unitNumber: `${i}C`,
          tenantName: "",
          emergencyContact: "",
          type: "Residential",
        },
        {
          unitNumber: `${i}D`,
          tenantName: "",
          emergencyContact: "",
          type: "Residential",
        },
        {
          unitNumber: `${i}E`,
          tenantName: "",
          emergencyContact: "",
          type: "Residential",
        },
        {
          unitNumber: `${i}F`,
          tenantName: "",
          emergencyContact: "",
          type: "Residential",
        },
        {
          unitNumber: `${i}G`,
          tenantName: "",
          emergencyContact: "",
          type: "Residential",
        },
        {
          unitNumber: `${i}H`,
          tenantName: "",
          emergencyContact: "",
          type: "Residential",
        },
      ];
    }
    // Floors 9-31 (varying units)
    else if (i >= 9 && i <= 31) {
      const units = [];
      const unitLetters = [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
      ];

      // Special cases for combined units
      if (
        i === 15 ||
        i === 19 ||
        i === 21 ||
        i === 22 ||
        i === 23 ||
        i === 24 ||
        i === 25 ||
        i === 26 ||
        i === 27 ||
        i === 29
      ) {
        units.push({
          unitNumber: `${i}AB`,
          tenantName: "",
          emergencyContact: "",
          type: "Residential",
        });
        units.push({
          unitNumber: `${i}C`,
          tenantName: "",
          emergencyContact: "",
          type: "Residential",
        });
      } else if (i === 16) {
        units.push({
          unitNumber: `${i}AB`,
          tenantName: "",
          emergencyContact: "",
          type: "Residential",
        });
        units.push({
          unitNumber: `${i}C`,
          tenantName: "",
          emergencyContact: "",
          type: "Residential",
        });
      } else if (i === 20) {
        units.push({
          unitNumber: `${i}A`,
          tenantName: "",
          emergencyContact: "",
          type: "Residential",
        });
        units.push({
          unitNumber: `${i}B`,
          tenantName: "",
          emergencyContact: "",
          type: "Residential",
        });
      } else if (i === 30) {
        units.push({
          unitNumber: `${i}ABC`,
          tenantName: "",
          emergencyContact: "",
          type: "Residential",
        });
        units.push({
          unitNumber: `${i}D`,
          tenantName: "",
          emergencyContact: "",
          type: "Residential",
        });
      } else {
        units.push({
          unitNumber: `${i}A`,
          tenantName: "",
          emergencyContact: "",
          type: "Residential",
        });
        units.push({
          unitNumber: `${i}B`,
          tenantName: "",
          emergencyContact: "",
          type: "Residential",
        });
      }

      // Add remaining units
      for (let j = 2; j < unitLetters.length; j++) {
        if (i === 25 || i === 26 || i === 27 || i === 28 || i === 30) {
          if (j === unitLetters.length - 1) {
            units.push({
              unitNumber: `${i}${unitLetters[j]}L`,
              tenantName: "",
              emergencyContact: "",
              type: "Residential",
            });
          } else {
            units.push({
              unitNumber: `${i}${unitLetters[j]}`,
              tenantName: "",
              emergencyContact: "",
              type: "Residential",
            });
          }
        } else {
          units.push({
            unitNumber: `${i}${unitLetters[j]}`,
            tenantName: "",
            emergencyContact: "",
            type: "Residential",
          });
        }
      }

      floorUnits = units;
    }
    // Floors 2-8 (15-17 units)
    else if (i >= 2 && i <= 8) {
      const units = [];
      const unitLetters = [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
      ];

      // Add all units for these floors
      for (let j = 0; j < unitLetters.length; j++) {
        units.push({
          unitNumber: `${i}${unitLetters[j]}`,
          tenantName: "",
          emergencyContact: "",
          type: "Residential",
        });
      }

      floorUnits = units;
    }

    floors.push({
      floorNumber: i,
      units: floorUnits,
    });
  }

  return floors;
};

const FLOORS_DATA = generateFloors();

function EmergencyCard({ unitNumber, emergency, onClick }) {
  const getEmergencyIcon = (type) => {
    const emergencyTypes = {
      "Fire Alarm": "🔥",
      "Water Leak": "💧",
      "Medical Emergency": "🚑",
      "Security Breach": "🚨",
      "Elevator Malfunction": "⚠️",
    };
    return emergencyTypes[type] || "⚠️";
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case "High":
        return "border-red-500 bg-red-50";
      case "Medium":
        return "border-orange-500 bg-orange-50";
      case "Low":
        return "border-yellow-500 bg-yellow-50";
      default:
        return "border-gray-500 bg-gray-50";
    }
  };

  return (
    <button
      onClick={onClick}
      className={`w-full p-4 rounded-lg border-l-4 shadow-sm hover:shadow-md transition-all ${getPriorityColor(
        emergency.priority
      )}`}
    >
      <div className="flex items-center space-x-3">
        <span className="text-2xl">{getEmergencyIcon(emergency.type)}</span>
        <div className="flex-1 text-left">
          <div className="font-semibold">Unit {unitNumber}</div>
          <div className="text-sm text-gray-600">{emergency.type}</div>
          <div className="text-xs text-gray-500">
            {new Date(emergency.timestamp).toLocaleString()}
          </div>
        </div>
      </div>
    </button>
  );
}

function StackingPlan() {
  const [selectedFloor, setSelectedFloor] = useState(null);
  const [selectedEmergency, setSelectedEmergency] = useState(null);
  const [showAddEmergencyModal, setShowAddEmergencyModal] = useState(false);
  const [emergencyData, setEmergencyData] = useState({});
  const [newEmergency, setNewEmergency] = useState({
    unitNumber: "",
    type: "Fire Alarm",
    details: "",
    actions: [],
    priority: "High",
    status: "Active",
  });
  const [actionInput, setActionInput] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [allEmergencies, setAllEmergencies] = useState([]); // Store all emergencies (including resolved)
  const { terms, getCapitalizedTerm } = useCompany();
  const navigate = useNavigate();
  const currentUser = useSelector((state) => state.userObject);
  const [selectedFiles, setSelectedFiles] = useState([]);

  useEffect(() => {
    // Subscribe to all emergencies collection
    const unsubscribe = queryAllDocsByFieldSnap(
      "emergencies",
      "unitNumber",
      "!=",
      "", // This will fetch all records
      (emergencyData) => {
        // Process active emergencies for the main state
        const activeEmergencies = emergencyData.filter(
          (e) => e.status === "Active"
        );

        // Convert array to object with unitNumber as key
        const formattedData = {};
        activeEmergencies.forEach((emergency) => {
          formattedData[emergency.unitNumber] = {
            type: emergency.type,
            timestamp: emergency.timestamp || emergency.createdAt,
            status: emergency.status,
            details: emergency.details,
            actions: emergency.actions || [],
            priority: emergency.priority,
            id: emergency.id,
            resolutionNotes: emergency.resolutionNotes || "",
            resolvedAt: emergency.resolvedAt || null,
            media: emergency.media || [], // Ensure media is included
          };
        });

        setEmergencyData(formattedData);
        setAllEmergencies(emergencyData); // Store all emergencies
        setIsLoading(false);
      }
    );

    // Cleanup subscription on unmount
    return () => unsubscribe && unsubscribe();
  }, []);

  const getTypeColor = (type) => {
    switch (type) {
      case "Retail":
        return "#8FCD00";
      case "Penthouse":
        return "#FFD700";
      case "Amenity":
        return "#4B9CD3";
      default:
        return "#363062";
    }
  };

  const getEmergencyIcon = (unitNumber) => {
    // Convert the unit number to uppercase for case-insensitive comparison
    const normalizedUnitNumber = unitNumber.toUpperCase();

    // Look for the emergency using normalized unit numbers
    const matchingEmergency = Object.keys(emergencyData).find(
      (key) => key.toUpperCase() === normalizedUnitNumber
    );

    if (!matchingEmergency) return null;

    const emergencyTypes = {
      "Fire Alarm": "🔥",
      "Water Leak": "💧",
      "Medical Emergency": "🚑",
      "Security Breach": "🚨",
      "Elevator Malfunction": "⚠️",
    };
    return emergencyTypes[emergencyData[matchingEmergency].type] || "⚠️";
  };

  const getEmergencyHistoryForUnit = (unitNumber) => {
    // Convert the unit number to uppercase for case-insensitive comparison
    const normalizedUnitNumber = unitNumber.toUpperCase();

    // Get all emergencies (active and resolved) for this unit using case-insensitive comparison
    return allEmergencies
      .filter((e) => e.unitNumber.toUpperCase() === normalizedUnitNumber)
      .sort((a, b) => {
        const dateA = new Date(a.timestamp || a.createdAt || 0);
        const dateB = new Date(b.timestamp || b.createdAt || 0);
        return dateB - dateA; // Sort by most recent first
      });
  };

  const hasActiveEmergencies = Object.keys(emergencyData).length > 0;
  const activeEmergencyFloors = [
    ...new Set(Object.keys(emergencyData).map((unit) => unit.slice(0, -1))),
  ];

  const handleAddEmergency = async () => {
    try {
      if (!newEmergency.unitNumber || !newEmergency.details) {
        alert("Please fill in all required fields");
        return;
      }

      const timestamp = new Date().toISOString();

      // Normalize the unit number format
      const normalizedUnitNumber = newEmergency.unitNumber.replace(
        /^(\d+)([a-zA-Z].*)$/i,
        (_, num, letter) => {
          return `${num}${letter.toUpperCase()}`;
        }
      );

      // Upload any attached media
      const uploadedUrls = await uploadFiles();

      const emergencyRecord = {
        unitNumber: normalizedUnitNumber,
        type: newEmergency.type,
        details: newEmergency.details,
        actions: newEmergency.actions.map((action) => ({
          action,
          addedBy: currentUser.displayName || currentUser.email,
          addedById: currentUser.uid,
          timestamp: new Date().toISOString(),
        })),
        priority: newEmergency.priority,
        status: newEmergency.status,
        timestamp: timestamp,
        createdAt: new Date(),
        media: uploadedUrls,
      };

      const docRef = await addNewDoc("emergencies", emergencyRecord);

      if (docRef) {
        setNewEmergency({
          unitNumber: "",
          type: "Fire Alarm",
          details: "",
          actions: [],
          priority: "High",
          status: "Active",
        });
        setActionInput("");
        setSelectedFiles([]);
        setShowAddEmergencyModal(false);
      }
    } catch (error) {
      console.error("Error adding emergency:", error);
      alert("Failed to add emergency record");
    }
  };

  const handleEmergencyResolved = () => {
    setSelectedEmergency(null);
  };

  const handleEmergencyEdited = (updatedEmergency) => {
    // Update the local state to reflect changes immediately
    if (selectedEmergency) {
      // Create a new object for the updated emergency with all properties
      const updatedEmergencyData = {
        ...selectedEmergency.emergency,
        ...updatedEmergency,
        media: updatedEmergency.media || [], // Ensure media is included
      };

      // Update the selected emergency
      setSelectedEmergency({
        ...selectedEmergency,
        emergency: updatedEmergencyData,
      });

      // Also update the emergency data state to reflect changes in the main list
      setEmergencyData((prevData) => ({
        ...prevData,
        [selectedEmergency.unitNumber]: updatedEmergencyData,
      }));
    }
  };

  const addAction = () => {
    if (actionInput.trim()) {
      setNewEmergency({
        ...newEmergency,
        actions: [...newEmergency.actions, actionInput.trim()],
      });
      setActionInput("");
    }
  };

  const removeAction = (index) => {
    const updatedActions = [...newEmergency.actions];
    updatedActions.splice(index, 1);
    setNewEmergency({
      ...newEmergency,
      actions: updatedActions,
    });
  };

  // Fix toast notifications by using navigate function instead of Link
  const handleNavigateToStackingPlan = () => {
    // Use navigate to go to the stacking plan
    navigate("/resident-management?link=Stacking+Plan");
  };

  const uploadFiles = async () => {
    // If no files selected, return empty array
    if (!selectedFiles || selectedFiles.length === 0) {
      return [];
    }

    try {
      // For simplicity, we're just returning URLs. In production, you'd use uploadFile
      // to actually upload the files to storage
      return selectedFiles.map((file) => ({
        url: URL.createObjectURL(file),
        name: file.name,
        type: file.type.startsWith("image/") ? "image" : "video",
        timestamp: new Date().toISOString(),
        uploadedBy: currentUser.displayName || currentUser.email,
        uploadedById: currentUser.uid,
      }));
    } catch (error) {
      console.error("Error uploading files:", error);
      return [];
    }
  };

  return (
    <div className="p-6" style={{ backgroundColor: "#F5F5F5" }}>
      {/* Emergency Actions */}
      <div className="flex justify-between mb-4">
        <h1 className="text-lg font-bold" style={{ color: "#363062" }}>
          Stacking Plan
        </h1>
        <button
          onClick={() => setShowAddEmergencyModal(true)}
          className="bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700 transition-colors"
        >
          Add Emergency
        </button>
      </div>

      {/* Active Emergencies Section */}
      {hasActiveEmergencies && (
        <div className="mb-6">
          <h2
            className="text-base font-semibold mb-3"
            style={{ color: "#363062" }}
          >
            Active Emergencies
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {Object.entries(emergencyData).map(([unitNumber, emergency]) => (
              <EmergencyCard
                key={unitNumber}
                unitNumber={unitNumber}
                emergency={emergency}
                onClick={() => setSelectedEmergency({ unitNumber, emergency })}
              />
            ))}
          </div>
        </div>
      )}

      {/* Emergency Modal */}
      {selectedEmergency && (
        <EmergencyModal
          unitNumber={selectedEmergency.unitNumber}
          emergency={selectedEmergency.emergency}
          onClose={() => setSelectedEmergency(null)}
          onResolve={handleEmergencyResolved}
          onEdit={handleEmergencyEdited}
        />
      )}

      {/* Add Emergency Modal */}
      {showAddEmergencyModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-start mb-4">
                <h2 className="text-lg font-bold text-gray-900">
                  Add New Emergency
                </h2>
                <button
                  onClick={() => setShowAddEmergencyModal(false)}
                  className="text-gray-400 hover:text-gray-500"
                >
                  <svg
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>

              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    ${unitNumberLabel}*
                  </label>
                  <input
                    type="text"
                    value={newEmergency.unitNumber}
                    onChange={(e) =>
                      setNewEmergency({
                        ...newEmergency,
                        unitNumber: e.target.value,
                      })
                    }
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    placeholder="e.g. 40C"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Emergency Type
                  </label>
                  <select
                    value={newEmergency.type}
                    onChange={(e) =>
                      setNewEmergency({
                        ...newEmergency,
                        type: e.target.value,
                      })
                    }
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  >
                    <option value="Fire Alarm">Fire Alarm</option>
                    <option value="Water Leak">Water Leak</option>
                    <option value="Medical Emergency">Medical Emergency</option>
                    <option value="Security Breach">Security Breach</option>
                    <option value="Elevator Malfunction">
                      Elevator Malfunction
                    </option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Priority
                  </label>
                  <select
                    value={newEmergency.priority}
                    onChange={(e) =>
                      setNewEmergency({
                        ...newEmergency,
                        priority: e.target.value,
                      })
                    }
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                  >
                    <option value="High">High</option>
                    <option value="Medium">Medium</option>
                    <option value="Low">Low</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Details*
                  </label>
                  <textarea
                    value={newEmergency.details}
                    onChange={(e) =>
                      setNewEmergency({
                        ...newEmergency,
                        details: e.target.value,
                      })
                    }
                    rows={3}
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                    placeholder="Describe the emergency"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Actions Taken
                  </label>
                  <div className="flex mt-1">
                    <input
                      type="text"
                      value={actionInput}
                      onChange={(e) => setActionInput(e.target.value)}
                      className="block w-full rounded-l-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                      placeholder="Add an action"
                    />
                    <button
                      type="button"
                      onClick={addAction}
                      className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-r-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                      Add
                    </button>
                  </div>
                  <ul className="mt-2 space-y-1">
                    {newEmergency.actions.map((action, index) => (
                      <li
                        key={index}
                        className="flex justify-between items-center bg-gray-50 p-2 rounded-md"
                      >
                        <span className="text-sm text-gray-700">{action}</span>
                        <button
                          type="button"
                          onClick={() => removeAction(index)}
                          className="text-red-500 hover:text-red-700"
                        >
                          ✕
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="mt-5 sm:mt-6">
                <button
                  type="button"
                  onClick={handleAddEmergency}
                  className="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:text-sm"
                >
                  Add Emergency
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {/* Floor selector */}
        <div className="md:col-span-1 bg-white rounded-lg shadow-md p-4 max-h-[80vh] overflow-y-auto">
          <h2
            className="text-base font-semibold mb-4"
            style={{ color: "#363062" }}
          >
            Floors
          </h2>
          <div className="space-y-1">
            {FLOORS_DATA.map((floor) => {
              const hasEmergency = activeEmergencyFloors.includes(
                floor.floorNumber.toString()
              );
              return (
                <button
                  key={floor.floorNumber}
                  className={`w-full p-2 text-left rounded-md transition-colors text-sm ${
                    selectedFloor === floor.floorNumber
                      ? "text-white"
                      : hasEmergency
                      ? "text-red-700 bg-red-100 hover:bg-red-200"
                      : "text-gray-700 hover:text-white"
                  }`}
                  style={{
                    backgroundColor:
                      selectedFloor === floor.floorNumber
                        ? "#363062"
                        : hasEmergency
                        ? ""
                        : "#F5F5F5",
                    borderLeft: `3px solid ${
                      selectedFloor === floor.floorNumber
                        ? "#8FCD00"
                        : hasEmergency
                        ? "#EF4444"
                        : "transparent"
                    }`,
                  }}
                  onClick={() => setSelectedFloor(floor.floorNumber)}
                >
                  Floor {floor.floorNumber}
                  {/* {floor.floorNumber === 4 && " (Amenity)"} */}
                  {floor.floorNumber === 55 && " (Penthouse)"}
                  {hasEmergency && (
                    <span className="float-right text-red-600">⚠️</span>
                  )}
                </button>
              );
            })}
          </div>
        </div>

        {/* Units display */}
        <div className="md:col-span-3">
          {selectedFloor ? (
            <div className="bg-white rounded-lg shadow-md p-6">
              <h2
                className="text-base font-semibold mb-4"
                style={{ color: "#363062" }}
              >
                {getCapitalizedTerm("location")} {selectedFloor}{" "}
                {getCapitalizedTerm("units")}
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {FLOORS_DATA.find(
                  (f) => f.floorNumber === selectedFloor
                )?.units.map((unit) => {
                  // Use case-insensitive matching to find emergencies for this unit
                  const unitNumber = unit.unitNumber;
                  const normalizedUnitNumber = unitNumber.toUpperCase();

                  // Find matching emergency using case-insensitive comparison
                  const matchingEmergencyKey = Object.keys(emergencyData).find(
                    (key) => key.toUpperCase() === normalizedUnitNumber
                  );

                  const hasEmergency = !!matchingEmergencyKey;
                  const emergency = hasEmergency
                    ? emergencyData[matchingEmergencyKey]
                    : null;
                  const emergencyIcon = getEmergencyIcon(unitNumber);
                  const unitEmergencyHistory =
                    getEmergencyHistoryForUnit(unitNumber);
                  const hasEmergencyHistory = unitEmergencyHistory.length > 0;

                  return (
                    <div
                      key={unit.unitNumber}
                      className={`rounded-lg p-4 border transition-all hover:shadow-md ${
                        hasEmergency
                          ? "bg-red-50 border-red-300"
                          : hasEmergencyHistory
                          ? "bg-yellow-50 border-yellow-300"
                          : ""
                      }`}
                      style={{
                        borderColor: hasEmergency
                          ? "#EF4444"
                          : hasEmergencyHistory
                          ? "#F59E0B"
                          : "#363062",
                        borderWidth:
                          hasEmergency || hasEmergencyHistory ? "2px" : "1px",
                      }}
                    >
                      <div className="flex justify-between items-center mb-2">
                        <h3
                          className={`text-base font-semibold ${
                            hasEmergency
                              ? "text-red-600"
                              : hasEmergencyHistory
                              ? "text-yellow-600"
                              : ""
                          }`}
                        >
                          {unit.unitNumber}
                          {emergencyIcon && (
                            <span className="ml-2">{emergencyIcon}</span>
                          )}
                        </h3>
                        {unit.type && (
                          <span
                            className="text-xs px-2 py-1 rounded-full"
                            style={{
                              backgroundColor: getTypeColor(unit.type),
                              color: "white",
                            }}
                          >
                            {unit.type}
                          </span>
                        )}
                      </div>
                      <div className="space-y-1 text-sm">
                        {unit.amenityType ? (
                          <p className="text-gray-600">{unit.amenityType}</p>
                        ) : (
                          <>
                            <p className="flex justify-between">
                              <span className="text-gray-600">Tenant:</span>
                              <span className="font-medium">
                                {unit.tenantName || "Vacant"}
                              </span>
                            </p>
                            <p className="flex justify-between">
                              <span className="text-gray-600">Emergency:</span>
                              <span
                                className="font-medium"
                                style={{ color: "#8FCD00" }}
                              >
                                {unit.emergencyContact || "N/A"}
                              </span>
                            </p>

                            {/* Active Emergency Card */}
                            {hasEmergency && (
                              <div
                                className="mt-2 p-2 bg-red-100 rounded-md cursor-pointer"
                                onClick={() =>
                                  setSelectedEmergency({
                                    unitNumber: matchingEmergencyKey, // Use the exact key from emergencyData
                                    emergency: emergency,
                                  })
                                }
                              >
                                <p className="text-red-600 text-xs">
                                  <strong>{emergency.type}</strong>
                                  <br />
                                  <span className="text-red-500">
                                    {new Date(
                                      emergency.timestamp
                                    ).toLocaleString()}
                                  </span>
                                </p>
                                <p className="text-xs mt-1 text-red-700 truncate">
                                  {emergency.details.substring(0, 50)}
                                  {emergency.details.length > 50 ? "..." : ""}
                                </p>
                              </div>
                            )}

                            {/* Emergency History Indicator */}
                            {!hasEmergency && hasEmergencyHistory && (
                              <div className="mt-2">
                                <button
                                  className="text-xs text-yellow-600 hover:text-yellow-800 font-medium"
                                  onClick={() =>
                                    setSelectedEmergency({
                                      unitNumber:
                                        unitEmergencyHistory[0].unitNumber, // Use the exact unit number from the emergency record
                                      emergency: unitEmergencyHistory[0],
                                    })
                                  }
                                >
                                  {unitEmergencyHistory.length} past{" "}
                                  {unitEmergencyHistory.length === 1
                                    ? "emergency"
                                    : "emergencies"}
                                </button>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <div
              className="bg-white rounded-lg shadow-md p-6 text-center"
              style={{ color: "#363062" }}
            >
              Please select a floor to view units
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default StackingPlan;
